module.exports = __webpack_public_path__ + "static/media/cinqueTerre.65b3442b.jpg";